import { render, staticRenderFns } from "./stepFourDialog.vue?vue&type=template&id=5b2e8e70&"
import script from "./stepFourDialog.vue?vue&type=script&lang=js&"
export * from "./stepFourDialog.vue?vue&type=script&lang=js&"
import style0 from "./stepFourDialog.vue?vue&type=style&index=0&id=5b2e8e70&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports